import type { CSSProperties } from "react";

/**
 * 埋め込み先から差し替えられる背景画像のスタイルを作る。
 *
 * img の src はCSSから触れないので、画像は背景で置いて
 * `background-image: var(--showcan-xxx, url(...))` の形にする。
 * 変数を指定すれば埋め込み先のCSSが勝ち、指定が無ければ管理画面の画像が出る。
 *
 * @param variable 埋め込み先が指定する変数名（--showcan-avatar など）
 * @param url      管理画面やスクリプトタグで決まった画像。無ければ背景を描かない
 * @param overridable false なら変数を見ない（管理画面で「埋め込み先の指定を使う」をオフにした項目）
 */
export function imageStyle(variable: string, url?: string, overridable = true): CSSProperties {
  if (!overridable) return { backgroundImage: cssUrl(url) };
  return { backgroundImage: `var(${variable}, ${cssUrl(url)})` };
}

/**
 * url() に入れても壊れない形にする。
 *
 * 署名付きURLはクエリが長くカンマや括弧を含むため、引用符で囲んでから
 * 引用符とバックスラッシュだけを退避する。改行が入ると宣言ごと壊れるので落とす。
 */
function cssUrl(url?: string): string {
  const trimmed = url?.trim();
  if (!trimmed) return "none";

  const escaped = trimmed.replace(/[\\"]/g, "\\$&").replace(/[\r\n]/g, "");
  return `url("${escaped}")`;
}
